import React from 'react';
import { observer } from 'mobx-react-lite';
import { Avatar, Chip } from '@producer/ui-kit';

import { InfoTextLine } from '../../../components/texts/Texts';
import { ListViewItem } from '../../../components/list-view/list-view';
import { MemberRowActions } from './member-row-actions';
import { getRoleLabel } from '../constants/roles';
import { Member } from '../../../app/entities/member';
import styles from './member-item.module.scss';

type MemberItemProps = {
  member: Member;
};

const STATUS_CHIPS: Record<string, { label: string; variant: 'neutral' | 'danger' }> = {
  pending: { label: 'Pending', variant: 'neutral' },
  rejected: { label: 'Rejected', variant: 'danger' },
  inactive: { label: 'Inactive', variant: 'neutral' },
};

export const MemberItem: React.FC<MemberItemProps> = observer(({ member }) => {
  const statusChip = STATUS_CHIPS[member.status ?? ''];

  return (
    <ListViewItem className={styles.row}>
      <td className={styles.avatarCell}>
        <Avatar src={member.avatar} initials={member.initials} />
      </td>

      <td>{member.fullName}</td>
      <td>{member.email}</td>

      <td>
        <InfoTextLine value={getRoleLabel(member.role)} />
      </td>

      <td>{statusChip && <Chip variant={statusChip.variant}>{statusChip.label}</Chip>}</td>

      <td className={styles.actionCell}>
        <MemberRowActions member={member} />
      </td>
    </ListViewItem>
  );
});
